import { createReducer } from '@reduxjs/toolkit';
import { defaultFeatureFlags, FeatureFlags } from 'lib-shared-feature-flags';
import { User } from 'lib-shared-types-api';

import { appActions } from 'app/app.actions';
import { websocketActions } from 'app/middleware/websocket/actions/websocket';
import { userModalActions } from 'components/usersModal';

import { profileActions } from './settingsProfile.actions';

type ProfileState = {
  profile: User;
  featureflags: FeatureFlags;
};

const initialState: ProfileState = {
  profile: {
    id: '',
    name: '',
    email: null,
    phone_number: null,
    avatar_url: '',
    type: 'member',
    default_outbound_number: null,
    org_id: null,
    has_scim_enabled: false,
    external_id: null,
    given_name: null,
    family_name: null,
    additional_emails: [],
    additional_phone_numbers: [],
    company_id: null,
    anonymized_at: null,
  },
  featureflags: defaultFeatureFlags,
};

export const profileReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(profileActions.update, (state, action) => {
      Object.assign(state.profile, action.payload.user);
    })

    .addCase(websocketActions.createFulfilled, (state, action) => {
      Object.assign(state.profile, action.payload.params.user);
    })

    .addCase(userModalActions.user.update.fulfilled, (state, action) => {
      if (action.payload.data.id === state.profile.id) {
        Object.assign(state.profile, action.payload.data);
      }
    })

    .addCase(appActions.getFeatureFlags.fulfilled, (state, action) => {
      state.featureflags = action.payload.flags;
    }),
);
